<template>
  <div id="app">
    <app-header />
    <app-slider />
  </div>
</template>

<script>
import AppHeader from "./components/header";
import AppSlider from "./components/slider";

export default {
  name: "App",

  components: {
    AppHeader,
    AppSlider
  }
};
</script>

<style>
@import "./css/style.css";
</style>
